import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=024921cb&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "../assets/css/inbox.css?vue&type=style&index=0&id=024921cb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024921cb",
  null
  
)

export default component.exports